module.exports = __webpack_public_path__ + "static/media/mv_bg.d8a05876.jpg";